/* Core & libraries */
import React, { useState } from "react";
import { useTheme } from "react-jss";
import { FormattedMessage } from "react-intl";
import ContainerFluid from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import UCButton from "../../buttons/index.js";

/* Helpers, constants, custom methods, internal libraries */
import { assignTypes } from "../../../constants/appConstants.js";
/* Components */

/* Styles */
import styles from "./styles.js"
import { colors } from "../../../constants/colors.js";

const Content = props => {
  const { setShowModal, handleSubmit, assignData, setAssignData, confirmButtonText, type, cardText, initialGroupData } = props;
  const theme = useTheme();
  const classes = styles({ theme });
  const handleFormSubmit = () => {
    handleSubmit();
  };
  const handleAssignCheckbox = (id) => {
    const updatedAssignData = type === assignTypes.card ? [...assignData.response.groups] : [...assignData.response.teams];

    if (type === assignTypes.card) {
      const fopIndex = updatedAssignData[id].fopInfoList.findIndex(fop => fop.fopUUID === assignData?.row?.fopUUID);

      if (fopIndex !== -1) {
        if (updatedAssignData[id].fopInfoList[fopIndex].fSelected) {
          // Remove the item from fopInfoList if unchecked
          updatedAssignData[id].fopInfoList.splice(fopIndex, 1);
        } else {
          // Reassign the card to its initial state if checked
          updatedAssignData[id].fopInfoList[fopIndex] = {
            ...initialGroupData[id].fopInfoList[fopIndex]
          };
        }
      } else {
        // Assign the new card information if it doesn't exist
        updatedAssignData[id].fopInfoList.push({
          vendorName: cardText(assignData.row.cardType),
          cardNumberMask: assignData.row.cardNumberMasked,
          fCardAssign: true,
          fSelected: true,
          fopUUID: assignData.row.fopUUID
        });
      }

      setAssignData({
        ...assignData,
        response: {
          ...assignData.response,
          groups: updatedAssignData
        }
      });
    } else if (type === assignTypes.policy) {
      if (assignData?.response?.teams[id]?.policyId === assignData?.row?.policyId) {
        if (assignData?.row?.policyId !== initialGroupData?.[id]?.policyId) {
          // Assign the initial policy if the policy id is not the current one (default assigned)
          updatedAssignData[id] = {
            ...initialGroupData[id]
          };
        } else {
          // Unassign if default assigned
          updatedAssignData[id] = {
            ...initialGroupData[id],
            policyName: undefined,
            policyId: undefined
          };
        }
      } else {
        // Assign the current policy
        updatedAssignData[id] = {
          ...initialGroupData[id],
          policyName: assignData.row.policyName,
          policyId: assignData.row.policyId
        };
      }

      setAssignData({
        ...assignData,
        response: {
          teams: updatedAssignData
        }
      });
    }
  };

  const getAssignedLogic = (team) => {
    if (type === assignTypes.card) {
      const currentFopInfo = team?.fopInfoList?.find(fop => fop.fopUUID === assignData?.row?.fopUUID && fop.fSelected);
      return currentFopInfo !== undefined;
    } else if (type === assignTypes.policy) {
      return team?.policyId === assignData?.row?.policyId;
    }
    return false;
  };

  return (
    <div className={classes.modalContent}>
      <div className={classes.listContainer}>
        {(type === assignTypes.card ? assignData.response.groups : assignData.response.teams)?.map((team, id) => {
          const applyBold = type === assignTypes.card ?
            team?.fopInfoList?.length !== initialGroupData[id]?.fopInfoList?.length :
            initialGroupData[id]?.policyId !== assignData.response.teams[id]?.policyId;

          // Get the current FOP info if available
          const currentFopInfo = type === assignTypes.card ? team?.fopInfoList?.find(fop => fop.fopUUID === assignData.row.fopUUID) : null;
          // If no current FOP, get the first element from the fopInfoList if available
          const firstFopInfo = !currentFopInfo && type === assignTypes.card && team?.fopInfoList?.length > 0 ? team.fopInfoList.find(elem => elem.vendorCode === "AS") || team.fopInfoList[0] : null;
          // Calculate additional cards count
          const additionalCardsCount = type === assignTypes.card && team?.fopInfoList?.length > 1 ? team?.fopInfoList?.length - 1 : 0;
          // Disable checkbox if there are 3 or more cards
          const disableCheckbox = type === assignTypes.card &&
            initialGroupData[id]?.fopInfoList?.length >= assignData?.response?.maxNumberCards &&
            !initialGroupData[id]?.fopInfoList?.some(fop => fop.fopUUID === assignData.row.fopUUID && fop.fSelected);

          return (
            <div key={id} className={`${getAssignedLogic(team) ? `${classes.optionContainer} ${classes.selectedOptionContainer}` : classes.optionContainer} ${disableCheckbox ? classes.disabledContainer: ""}`} onClick={() => !disableCheckbox && handleAssignCheckbox(id)}>
              <div className={classes.logo}>
                {type === assignTypes.card ? team.entityName?.split(" ").shift().charAt(0).toUpperCase() : team.teamName?.split(" ").shift().charAt(0).toUpperCase()}
              </div>
              <div className={classes.textContainer}>
                <h3>{type === assignTypes.card ? team.entityName : team.teamName}</h3>
                <p>
                  {type === assignTypes.card ? (
                    currentFopInfo ? (
                      <p className={`${applyBold ? classes.boldPar : ""}`}>
                        <FormattedMessage id="assignModal.endingIn" values={{ assignedCard: currentFopInfo.vendorName, endingCardNumber: currentFopInfo.cardNumberMask }} />
                        {additionalCardsCount > 0 && ` (+${additionalCardsCount} other card${additionalCardsCount > 1 ? 's' : ''})`}
                      </p>
                    ) : firstFopInfo ? (
                      <p className={`${applyBold ? classes.boldPar : ""}`}>
                        <FormattedMessage id="assignModal.endingIn" values={{ assignedCard: firstFopInfo.vendorName, endingCardNumber: firstFopInfo.cardNumberMask }} />
                        {additionalCardsCount > 0 && ` (+${additionalCardsCount} other card${additionalCardsCount > 1 ? 's' : ''})`}
                      </p>
                    ) : (
                      <p className={`${applyBold ? classes.boldPar : ""}`}>
                        <FormattedMessage id="assignModal.noCardAssigned" />
                      </p>
                    )
                  ) : (
                    team.policyName && team.policyId ? (
                      <p className={`${applyBold ? classes.boldPar : ""}`}>
                        <FormattedMessage id="assignModal.policyAssigned" values={{ policyName: team.policyName }} />
                      </p>
                    ) : (
                      <p className={`${applyBold ? classes.boldPar : ""}`}>
                        <FormattedMessage id="assignModal.noPolicyAssigned" />
                      </p>
                    )
                  )}
                </p>
              </div>
              <div className={classes.checkBoxDiv}>
                <input
                  type="checkbox"
                  name={type === assignTypes.card ? "team" : assignTypes.policy}
                  id={type === assignTypes.card ? "team" : assignTypes.policy}
                  checked={getAssignedLogic(team)}
                  disabled={disableCheckbox}
                />
              </div>
            </div>
          );
        })}
      </div>
      <div className={classes.btnContainer}>
        <ContainerFluid>
          <Row className={classes.btnsRow}>
            <Col className={classes.colCancel}>
              <UCButton
                onClick={() => setShowModal(false)}
                type="default"
                className={classes.cancelBtn}
                text={<FormattedMessage id="assignModal.cancel" />}
              />
            </Col>
            <Col className={classes.colRemove}>
              <UCButton
                className={classes.createBtn}
                onClick={handleFormSubmit}
                type="primary"
                text={confirmButtonText}
                dataTestId="assignModalContinueBtn"
                spinner={{
                  name: "assignModalSpinner",
                  size: 20,
                  color: colors.white
                }}
              />
            </Col>
          </Row>
        </ContainerFluid>
      </div>
    </div>
  );
};

export default Content;
